export default __webpack_public_path__ + "static/media/improve-mobility.4fd809ee.webp";